import Jt808SetMinRestingTimeModal from './jt808-set-min-resting-time-modal.vue'
export default Jt808SetMinRestingTimeModal
